import { LoaderFunctionArgs } from "react-router-dom";
import { forgotPasswordConfirm } from "../../actions/forgot-password";

export const forgotPasswordConfirmLoader = async (args: LoaderFunctionArgs) => {
  return await forgotPasswordConfirm();
};
